import { __assign, __rest } from "tslib";
import { createContext, useContext } from 'react';
export var RcDialogContext = createContext({});
export var useRcDialogContext = function () { return useContext(RcDialogContext); };
export var useDialogDefaultProps = function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    var context = useRcDialogContext();
    var _b = props.size, size = _b === void 0 ? context.size || 'medium' : _b;
    return __assign(__assign({}, props), { size: size });
};
